import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MatPaginator} from '@angular/material/paginator';
import {Subject} from 'rxjs';
import {PatientService} from '../../Services/patient.service';
import {ClientService} from '../../Services/client.service';
import {AuthService} from '../../auth/AuthService';
import {UserService} from '../../Services/UserService';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {DatePipe} from '@angular/common';
import {debounceTime, first} from 'rxjs/operators';
import swal from "sweetalert2";
import {format, isValid, parse} from 'date-fns';
import {Sort} from '@angular/material/sort';
import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {ReportService} from '../../Services/report.service';
import {MatSelectChange} from '@angular/material/select';
import {HttpResponse} from '@angular/common/http';



interface PatientPagination {
    page: number;        // API uses 1-based index
    size: number;        // Page size
    currentPage: number; // MatPaginator uses 0-based index
}

@Component({
    selector: 'pm-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css']
})


export class ReportComponent implements OnInit, AfterViewInit {

    tableData: any = [];
    assignArray: any = [];
    checked: boolean = false;
    agentArray: any = [];
    Elements: any;
    agent: any = null;
    totalRecord: any;
    page: number = 1;
    size: number = 10;
    currentPage = 0;
    sortDirection: 'asc' | 'desc' | null = null;
    sortField: any = null;
    searchString: any = null;
    searchPHolder: string = 'Search by name';
    button: string = 'Name';
    pBulkImport: FormGroup;
    files: File[] = [];
    isDragOver: boolean = false;
    fileImage: string | null = null; // Variable to hold the image URL
    selectedHeadersSequenceList: string[] = [];
    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];

    pagination: PatientPagination = {
        page: 1,         // API uses 1-based index
        size: 10,        // Default page size
        currentPage: 0   // MatPaginator uses 0-based index
    };
    selectedType: any = '';

    reportTypeArray = [
        //{value: 'CLIENT_WISE_ELIGIBILITY_VERIFICATION', viewValue: 'Client wise eligibility verification report'},
        {value: 'DAY_END_CLIENT_REPORT', viewValue: 'Day end client report'},
        {value: 'TOTAL_WORK_ORDER_ALLOCATED_BY_DAY', viewValue: 'Total work order allocated by day'},
        {value: 'WTD_CLIENT_REPORT', viewValue: 'WTD client report'},
        {value: 'MTD_CLIENT_REPORT', viewValue: 'MTD client report'},
        {value: 'CUSTOM_REPORT', viewValue: 'Customize report'},
        //{value: 'AGENT_MTD_REPORT', viewValue: 'Agent MTD report'},
        //{value: 'TOTAL_WORK_ORDER_ALLOCATED_BY_USER', viewValue: 'Total work order allocated by user'},
        //{value: 'AUDIT_QUALITY_REPORT', viewValue: 'Audit & quality report'},
        //{value: 'WORK_ORDER_FULL_DETAILS_REPORT', viewValue: 'Work order full details report'},
    ]

    reportType:any = '';

    headers = '';
    headerArray: any[] = [];
    selectedHeaders: string[] = [];
    getHeaders: any[] = [];
    selectedHeadersWithSequence: { [key: string]: number } = {};

    filterSelections = {
        date: false,
        status: null,            // 'active' | 'inactive' | 'all'
        verification: null,      // 'VERIFIED' | 'PENDING' | 'NOT_VERIFIED'
        userId: null,
        payerId: null,
        startDate: null,
        endDate: null
    };


    errorMessages: any;
    errorMessagePart: any;
    @ViewChild('fileDropRef') fileDropRef!: ElementRef;
    @ViewChild('searchBox') searchValue!: ElementRef;
    @ViewChild('bulkUpload') bulkUploadModal!: ElementRef;
    @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
    private clientSub: any;
    private subject: Subject<string> = new Subject();
    searchText: string = '';
    search: string = '';
    filterAgentArray = [...this.agentArray];
    userId: any = null;
    payerId: any = null;

    providerArray:any= [];
    payerArray: any[] = [
        { id: 1, name: "1199 National Benefit Fund of NY (PO Box 1149)", payerIdCode: "13551" },
        // Add more items to simulate large dataset
        ...Array.from({ length: 1356 }, (_, i) => ({ id: i + 2, name: `Payer ${i + 2}` }))
    ];
    filterPayerArray: any[] = [...this.payerArray];

    virtualScrollEnabled: boolean = true; // Toggle virtual scrolling
    @ViewChild('virtualScroll') virtualScrollViewport: CdkVirtualScrollViewport;

    @ViewChild('dropdownContainer') dropdownContainer: ElementRef;
    @ViewChild('startDate', {static: true}) startDateInput: ElementRef;
    @ViewChild('endDate', {static: true}) endDateInput: ElementRef;


    filterType: string | null = null; // Track selected filter type
    startDate: Date;
    endDate: Date;
    minEndDate: Date | null = null; // Minimum date for End Date
    isDropdownOpen = false;
    status: string | null = null;
    toggleClicked:boolean = false;
    date: Date = new Date();
    isLoading: boolean = false;
    isHeadersLoading: boolean = false;
    private reportRequestId = 0;

    constructor(private fb: FormBuilder,
                private patientService: PatientService,
                private clientService: ClientService,
                private reportService: ReportService,
                public authService: AuthService,
                private userServices: UserService,
                private router: Router,
                private dialog: MatDialog,
                private renderer: Renderer2,
                private datePipe: DatePipe,
                private cdr: ChangeDetectorRef,
                private ngZone: NgZone) {
        this._setSearchSubscription();
    }

    ngOnInit(): void {
        this.getAgents();
        /*this.getTableHeaders();*/
        this.loadPaginationState(); // Remove pagination state on reload
        this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
          if (clientId) {
            this.pagination.page = 1;
            this.pagination.currentPage = 0;
            this.getRequiredList().then(() => {
            });
          }
        });
        window.addEventListener('beforeunload', () => {
            sessionStorage.removeItem('reportPagination');
        });
    }
    ngOnDestroy(): void {
      this.clientSub?.unsubscribe();
    }
    async getRequiredList() {
    const paramsP = {
      isPayerNameAndId: true,
      clientId: this.authService?.clientId || null,
      duplicate: false
    };

    try {
      const payerResponse = await this.patientService.getPayer(paramsP).pipe(first()).toPromise();
      if (payerResponse) {
        this.ngZone.run(() => {
          this.payerArray = payerResponse;
          this.filterPayerArray = [...this.payerArray];
          this.cdr.detectChanges();
        });
      }
    } catch (error) {
      swal.fire({
        title: 'Error!',
        icon: 'error',
        text: error.error.message || 'Something went wrong!',
        showConfirmButton: false,
        timer: 5000
      });
    }

    try {
      const headerResponse = await this.reportService.getHeaders().pipe(first()).toPromise();
      if (headerResponse) {
        this.updateHeaders(headerResponse);
      }
    } catch (error) {
      swal.fire({
        title: 'Error!',
        icon: 'error',
        text: error.error.message || 'Something went wrong!',
        showConfirmButton: false,
        timer: 5000
      });
    }
  }

    /**
     * Loads the complete header master list.
     * For normal reports the same list is also used by the table.
     * For CUSTOM_REPORT pass false so the dropdown gets every available
     * header without replacing the customized table columns.
     */
    getTableHeaders(setAsTableHeaders: boolean = true): void {
      this.isHeadersLoading = true;

      this.reportService.getHeaders().pipe(first()).subscribe(
        (response: any[]) => {
          const allHeaders = Array.isArray(response) ? response : [];

          // The selector must always contain ALL available headers.
          this.headerArray = [...allHeaders];

          if (setAsTableHeaders) {
            this.getHeaders = [...allHeaders];
          }

          this.isHeadersLoading = false;
          this.cdr.detectChanges();
        },
        (error) => {
          this.isHeadersLoading = false;
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error?.message || 'Something went wrong!',
            showConfirmButton: false,
            timer: 5000
          });
        }
      );
    }

    /**
     * CUSTOM_REPORT needs two different header collections:
     * 1. headerArray -> every available header shown in the multi-select.
     * 2. getHeaders  -> only the user's saved/selected headers shown in table.
     */
    getCustomizedHeaders(): void {
      const params = {
        isHeaderWithName: true
      };

      // Do not let the all-header API replace the customized table columns.
      this.getTableHeaders(false);
      this.isHeadersLoading = true;

      this.reportService.getHeaders(params).pipe(first()).subscribe(
        (response: any[]) => {
          const customizedHeaders = Array.isArray(response) ? response : [];

          this.getHeaders = [...customizedHeaders];
          this.applySelectedHeaderState(customizedHeaders);

          this.isHeadersLoading = false;
          this.cdr.detectChanges();
        },
        (error) => {
          this.isHeadersLoading = false;
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error?.message || 'Something went wrong!',
            showConfirmButton: false,
            timer: 5000
          });
        }
      );
    }

    private applySelectedHeaderState(headers: any[]): void {
      this.selectedHeaders = headers
        .map(header => header?.enumValue)
        .filter(Boolean);

      this.selectedHeadersSequenceList = [...this.selectedHeaders];
      this.rebuildHeaderSequence();
    }

    private rebuildHeaderSequence(): void {
      this.selectedHeadersWithSequence = {};
      this.selectedHeadersSequenceList.forEach((header, index) => {
        this.selectedHeadersWithSequence[header] = index + 1;
      });
    }


    scrollToSelectedPayer(payerId: string) {
        if (!payerId || !this.virtualScrollViewport) return;

        const index = this.payerArray.findIndex((payer) => payer.id.toString() === payerId.toString());
        if (index > -1) {
            setTimeout(() => {
                this.virtualScrollViewport.scrollToIndex(index);
            });
        }
    }

    trackByFn(index: number, item: any) {
        return item.id;
    }

    clearPayerSelection(): void {
        this.payerId = null;
        this.filterPayerArray = [...this.payerArray];
        this.resetToFirstPage();
        this._fetchData();
    }


    toggleDropdown(): void {
        this.isDropdownOpen = !this.isDropdownOpen;
        this.toggleClicked = this.isDropdownOpen;
    }

    setFilterType(type: string) {
        this.filterType = type ? type : null;
        if (type === 'active') {
            this.selectedType = 2;
        } else if (type === 'inactive') {
            this.selectedType = 3;
        } else if (type === 'VERIFIED') {
            this.selectedType = 4;
        } else if (type === 'PENDING') {
            this.selectedType = 5;
        } else if (type === 'NOT_VERIFIED') {
            this.selectedType = 6;
        } else if (type === 'BACKLOG') {
            this.selectedType = 7;
        } else if (type === 'UNASSIGNED') {
            this.selectedType = 8;
        } else {
            this.selectedType = 1; // Default to "All"
        }
    }

    // Reset only the active filters; keep the currently selected report type/header setup.
    resetFilter(event?: MouseEvent): void {
      if (event) {
        event.stopPropagation();
      }

      this.isDropdownOpen = false;
      this.toggleClicked = false;
      this.filterType = null;
      this.selectedType = 1;
      this.startDate = null;
      this.endDate = null;
      this.payerId = null;
      this.userId = null;
      this.sortField = null;
      this.sortDirection = null;

      this.resetToFirstPage();
      this._fetchData();
    }

    private resetToFirstPage(): void {
    this.pagination.currentPage = 0;
    this.pagination.page = 1;
    sessionStorage.setItem('reportPagination', JSON.stringify(this.pagination));
  }

    @HostListener('document:click', ['$event.target'])
    onClickOutside(targetElement: HTMLElement): void {
        if(this.toggleClicked){
            const clickedInsideDropdown = this.dropdownContainer?.nativeElement.contains(targetElement);
            const clickedInsideDatepicker =
                this.startDateInput?.nativeElement.contains(targetElement) ||
                this.endDateInput?.nativeElement.contains(targetElement);
            const clickedInsideCalendar = !!targetElement.closest('.bs-datepicker'); // Check if inside the datepicker calendar

            if (!clickedInsideDropdown && !clickedInsideDatepicker && !clickedInsideCalendar) {
                // Closing the dropdown should not reset filters or trigger another API call.
                this.isDropdownOpen = false;
                this.toggleClicked = false;
            }
        }
    }

    onFilteredReturn(filteredArray: any[]): void {
        this.filterAgentArray = filteredArray;
    }

    onPayerFilteredReturn(filteredArray: any[]): void {
        this.filterPayerArray = filteredArray;
    }

    getAgents() {
        let params = {
            isWorkOrderUser: true,
            clientId: this.authService.clientId,
            duplicate: false
        };
        this.patientService.getAgents(params).pipe(first()).subscribe(
            (response: any) => {
                if (response) {
                    this.agentArray = response;
                    // Add `fullName` property to each agent in `agentArray`
                    this.agentArray = this.agentArray.map(agent => ({
                        ...agent,
                        fullName: `${agent.firstName} ${agent.lastName}`
                    }));

                    // Initialize `filterAgentArray` with the updated `agentArray`
                    this.filterAgentArray = [...this.agentArray];
                    /* this.filterAgentArray = this.agentArray.filter(agent =>
                         `${agent.firstName} ${agent.lastName}`
                             .toLowerCase()
                             .includes(this.searchText.toLowerCase())
                     );*/

                }
            });
    }

    // clear the search in the dropdown select search input
    dropdownSearchClear(event: any) {
        event.target.value = null;
        setTimeout(() => {
            this.filterAgentArray = this.agentArray;
        }, 500);
    }


    ngAfterViewInit() {
      if (this.paginator) {
        this.paginator.pageIndex = this.pagination.currentPage;
      }
    }

    onKeyUp(searchTextValue: any): void {
        this.subject.next(searchTextValue);
    }

    private _setSearchSubscription(): void {
      this.subject.pipe(
        debounceTime(300)
      ).subscribe((searchValue: string) => {
        const value = (searchValue || '').trim();

        if (!value) {
          this.searchString = '';
          this.resetToFirstPage();
          this._fetchData();
        }
      });
    }


    onSearch() {
        let inputValue = this.searchValue.nativeElement.value;

        if (inputValue) {
            // Decode any URL-encoded characters like %20 to a normal string
            inputValue = decodeURIComponent(inputValue);

            // Use a regular expression to determine if the input looks like a date
            const isDateLike = this.isDateLike(inputValue);

            if (isDateLike) {
                // If it looks like a date, try formatting it
                this.formatDateString(inputValue);
            } else {
                // Otherwise, treat it as a normal search string
                this.searchString = inputValue;
                this.searchPatient();
            }
        }
    }

    handleKeyUp(event: KeyboardEvent) {
      const value = (event.target as HTMLInputElement).value;

      // Trigger search on Enter
      if (event.key === 'Enter') {
        this.onSearch();
        return;
      }

      // Existing debounce logic
      this.subject.next(value);
    }
    clearSearch(input: HTMLInputElement) {
      input.value = '';
      this.searchString = '';
      this.resetToFirstPage();
      this._fetchData();
    }

// Helper function to check if a string looks like a date
    isDateLike(input: string): boolean {
        // Regular expression to check for common date patterns
        const datePattern = /^(\d{1,2}[-\/]\d{1,2}[-\/]\d{2,4})|(\d{4}[-\/]\d{1,2}[-\/]\d{1,2})|([A-Za-z]+\s\d{1,2},\s\d{4})$/;

        // Test the input against the date pattern
        return datePattern.test(input);
    }

    formatDateString(inputDate: string) {
        // Define possible date formats to parse the input date
        const formats = [
            'MM/dd/yyyy',
            'dd/MM/yyyy',
            'yyyy/MM/dd',
            'yyyy-MM-dd',
            'dd-MM-yyyy',
            'MM-dd-yyyy',
            'MMMM dd, yyyy',    // e.g., "October 15, 2024"
            'yyyy/MM/dd HH:mm',  // e.g., "2024/10/15 14:30"
            'MM/dd/yyyy HH:mm',  // e.g., "10/15/2024 14:30"
            'dd-MM-yyyy HH:mm',  // e.g., "15-10-2024 14:30"
        ];

        let parsedDate: Date | null = null;

        // Try parsing the input date with each format
        for (const formatStr of formats) {
            parsedDate = parse(inputDate, formatStr, new Date());
            if (isValid(parsedDate)) {
                break;  // Stop if a valid date is found
            }
        }

        // If a valid date was parsed, format it to 'MM/dd/yyyy'
        if (parsedDate && isValid(parsedDate)) {
            const formattedDate = format(parsedDate, 'MM/dd/yyyy');
            this.searchString = formattedDate; // Set the formatted date as the search string

            // Call the search function with the formatted date
            this.searchPatient();
        }
        // If no valid date is found, simply do nothing (no error message shown)
    }

    formatStartOfDay(date: Date | string | null): string | null {
        if (!date) {
            return null;
        }

        const dateObj = new Date(date);
        dateObj.setHours(0, 0, 0, 0);
        return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
    }

    formatEndOfDay(date: Date | string | null): string | null {
        if (!date) {
            return null;
        }

        const dateObj = new Date(date);
        dateObj.setHours(23, 59, 59, 999);
        return this.datePipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss');
    }

    searchPatient(): void {
      this.searchString = (this.searchString || '').trim();
      this.selectedType = 1;
      this.resetToFirstPage();

      // Keep report search, pagination, filters and sorting on the same endpoint.
      this._fetchData(1);
    }

    updateSelectedHeaders(event: MatSelectChange): void {
        const newSelection: string[] = event.value;

        // Add newly selected headers to the sequence list if not already present
        newSelection.forEach(header => {
            if (!this.selectedHeadersSequenceList.includes(header)) {
                this.selectedHeadersSequenceList.push(header);
            }
        });

        // Remove headers that have been deselected
        this.selectedHeadersSequenceList = this.selectedHeadersSequenceList.filter(header =>
            newSelection.includes(header)
        );

        this.selectedHeaders = [...newSelection];

        // Rebuild sequence mapping based on actual selection order.
        this.rebuildHeaderSequence();
    }

// Helper method to get sequence number for display
    getSequenceNumber(enumValue: string): number | null {
        return this.selectedHeadersWithSequence[enumValue] || null;
    }
    getDisplayNameWithOrder(header: string, index: number): string {
        const matched = this.headerArray.find(opt => opt.enumValue === header);
        return `${index + 1}. ${matched ? matched.displayName : header}`;
    }
    setHeader(isAssigned?: boolean) {
        this.getHeaders = [];
        if (this.reportType !== null) {
            let reqData = this.selectedHeadersWithSequence;

            this.reportService.postHeaders(reqData).pipe(first()).subscribe(
                (response: any) => {
                    if (response != undefined && Array.isArray(response)) {
                        // Only update the table headers. headerArray intentionally
                        // remains the complete list so unselected headers stay available.
                        this.getHeaders = [...response];
                        this.applySelectedHeaderState(response);

                        swal.fire({
                            icon: 'success',
                            text: 'Done',
                            showConfirmButton: false,
                            timer: 3000
                        });
                        this.userId = null;
                    } else {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: response?.message || 'Unknown error',
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                },
                (error) => {
                    swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        text: error.error?.message || 'Something went wrong',
                        showConfirmButton: false,
                        timer: 5000
                    });
                }
            );
        } else {
            swal.fire({
                title: 'Error!',
                icon: 'error',
                text: 'Please select at least one patient',
                showConfirmButton: false,
                timer: 5000
            });
            this.userId = null;
        }
    }

    private updateTable(response: any) {
      this.ngZone.run(() => {
        this.tableData = [...(response?.content || response || [])];
        this.totalRecord = response?.totalElements || 0;
        this.Elements = this.totalRecord;

        if (this.paginator) {
          this.paginator.pageIndex = this.pagination.currentPage;
        }

        this.cdr.detectChanges();
      });
    }

    private updateHeaders(response: any[]): void {
        this.ngZone.run(() => {
          const headers = Array.isArray(response) ? response : [];
          this.getHeaders = [...headers];
          this.headerArray = [...headers];
          this.cdr.detectChanges();
        });
      }

    trackByHeader(index: number, header: any): string | number {
      return header?.enumValue || header?.fieldName || index;
    }

    setReportType(type: any) {
    this.reportType = type;
    this.resetToFirstPage();
    this.tableData = [];
    this.totalRecord = 0;
    this.Elements = 0;

    if (type !== 'CUSTOM_REPORT') {
      this.getTableHeaders();
      this._fetchData();
    } else {
      this.getHeaders = [];
      this.selectedHeaders = [];
      this.selectedHeadersSequenceList = [];
      this.selectedHeadersWithSequence = {};
      this.getCustomizedHeaders();
    }
  }

    // Get Client data
    _fetchData(type?: any) {

      let params: { [key: string]: any } = {
        page: this.pagination.page,
        size: this.pagination.size,
        clientId: this.authService.getClientId() || null,
        reportType: this.reportType || null,
        userTimeZone: this.authService.getTimeZone(),
        duplicate: false
      };

      // ✅ Report type based dates
      if (this.reportType === 'CUSTOM_REPORT') {
        params.startDate = this.formatStartOfDay(this.startDate);
        params.endDate = this.formatEndOfDay(this.endDate);
      }

      if (
        this.reportType === 'TOTAL_WORK_ORDER_ALLOCATED_BY_DAY' ||
        this.reportType === 'DAY_END_CLIENT_REPORT'
      ) {
        params.startDate = this.formatStartOfDay(this.date);
      }

      // ✅ Sorting
      if (this.sortField && this.sortDirection) {
        params.sort = `${this.sortField},${this.sortDirection}`;
      }

      // ✅ Optional filters
      if (this.userId !== null) {
        params.userId = this.userId;
      }

      if (this.payerId !== null) {
        params.payerId = this.payerId;
      }

      let filterType = type ?? this.selectedType;

      // ✅ Filter logic (FIXED condition bug)
      if (filterType === 1 && this.searchString?.trim()) {
        params.searchString = this.searchString.trim();
      }
      else if (filterType === 2) {
        params.active = true;
      }
      else if (filterType === 3) {
        params.active = false;
      }

      // ✅ Verification filters (grouped cleanly)
      const verificationMap: any = {
        4: 'VERIFIED',
        5: 'PENDING',
        6: 'NOT_VERIFIED',
        7: 'BACKLOG',
        8: 'UNASSIGNED'
      };

      if (verificationMap[filterType]) {
        params.verification = verificationMap[filterType];
        params.startDate = this.formatStartOfDay(this.startDate);
        params.endDate = this.formatEndOfDay(this.endDate);
      }

      // ✅ Clean params
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === null) {
          delete params[key];
        }
      });

      // Keep only the latest request result when users sort/filter/page quickly.
      const requestId = ++this.reportRequestId;
      this.isLoading = true;

      this.reportService.getReport(params).pipe(first()).subscribe(
        (response: any) => {
          if (requestId !== this.reportRequestId) {
            return;
          }

          this.updateTable(response);
          this.isLoading = false;
        },
        (error) => {
          if (requestId !== this.reportRequestId) {
            return;
          }

          this.tableData = [];
          this.totalRecord = 0;
          this.Elements = 0;
          this.isLoading = false;
          this.cdr.detectChanges();

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error?.error?.message || 'Unable to load report data.',
            showConfirmButton: false,
            timer: 5000
          });

          this.isDropdownOpen = false;
          this.toggleClicked = false;
        }
      );
    }

    removeImage(): void {
        this.errorMessages = null;
        this.errorMessagePart = null;
        this.files = null;       // Optionally clear the file data as well
        this.fileImage = null;  // Clear the image source
    }

    // pagination changes
    pageChange(event: any) {
        this.pagination.currentPage = event.pageIndex;
        this.pagination.page = this.pagination.currentPage + 1;
        this.pagination.size = event.pageSize;

        sessionStorage.setItem('reportPagination', JSON.stringify(this.pagination));

        this._fetchData(); // Fetch data using selectedType
    }

    loadPaginationState() {
        const storedData = sessionStorage.getItem('reportPagination');

        if (storedData) {
            this.pagination = JSON.parse(storedData);
        }
    }

    sortData(sort: Sort) {
        this.sortField = sort.active;
        this.sortDirection = sort.direction === '' ? null : sort.direction;
        // Fetch data with the sorting parameters
        this._fetchData();
    }

    onSort(sort: Sort) {
        const sortField = sort.active;
        const sortDirection: 'asc' | 'desc' = sort.direction === '' ? 'asc' : sort.direction;
        // Call your sorting function
        this.setSorting(sortField, sortDirection);
    }

    setSorting(sortField: string, sortDirection: 'asc' | 'desc') {
        const sortParam = `sort=${sortField},${sortDirection}`;
        this._fetchData();
    }

    logout() {
        // Clear session storage during logout
        sessionStorage.removeItem('reportPagination');
        this.authService.logout();
    }

    trackByIndex(index: number, item: any): number {
        return index;
    }
    applyReportFilter(): void {

  // Always restart from first page when applying filters
  this.resetToFirstPage();

  /*
   * selectedType is already populated by setFilterType():
   *
   * 1 = All / Date / Agent / Payer
   * 2 = Active
   * 3 = Inactive
   * 4 = VERIFIED
   * 5 = PENDING
   * 6 = NOT_VERIFIED
   * 7 = BACKLOG
   * 8 = UNASSIGNED
   */
  const type = this.selectedType || 1;

  this._fetchData(type);

  this.isDropdownOpen = false;
  this.toggleClicked = false;
    }
    onAgentFilterChange(): void {
      this.filterType = 'agent';
    }


    onPayerFilterChange(): void {
      this.filterType = 'payer';
    }


    markDateFilterActive(): void {
      this.filterType = 'date';
    }    

   exportData() {

    const params: { [key: string]: any } = {
        clientId: this.authService.getClientId() || null,
        isExport: true,
        reportType: this.reportType ?? null,
        userTimeZone: this.authService.getTimeZone(),
    };

    // Add date fields based on report type
    if (this.reportType === 'CUSTOM_REPORT') {
        params.startDate = this.formatStartOfDay(this.startDate);
        params.endDate = this.formatEndOfDay(this.endDate);
        params.size = this.Elements;
    } else if (this.reportType === 'TOTAL_WORK_ORDER_ALLOCATED_BY_DAY' || this.reportType === 'DAY_END_CLIENT_REPORT') {
        params.startDate = this.formatStartOfDay(this.date);
        params.endDate = this.formatEndOfDay(this.date); // optional, if needed
        params.size = this.Elements;
    } else {
        /*params.startDate = this.formatStartOfDay(this.startDate);
        params.endDate = this.formatEndOfDay(this.endDate);*/
      params.size = this.Elements;
    }

    this.reportService.getExportFile(null, params).subscribe(
        (response: HttpResponse<Blob>) => {
            try {
                const contentDisposition = response.headers.get('Content-Disposition');
                let filename = 'report.xlsx';
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/);
                  if (match) {
                    filename = decodeURIComponent(match[1] || match[2]);
                  }
                }

                const blob = new Blob([response.body!], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                const downloadURL = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadURL;
                link.download = filename;
                link.click();

                window.URL.revokeObjectURL(downloadURL);

                swal.fire({
                    icon: 'success',
                    title: 'Download Successful',
                    text: `The file "${filename}" has been downloaded successfully.`,
                    timer: 3000,
                    timerProgressBar: true
                });
            } catch (error) {
                swal.fire({
                    icon: 'error',
                    title: 'Download Failed',
                    text: 'An unexpected error occurred while processing the file.',
                });
            }
        },
        (error) => {
            swal.fire({
                icon: 'error',
                title: 'Download Failed',
                text: error?.message || 'Unable to download the file. Please try again later.',
            });
        }
    );
    }

    getSelectedHeaderNames(): string {
      if (!this.selectedHeaders || this.selectedHeaders.length === 0) {
        return 'Select Headers';
      }

      const names = this.selectedHeaders
        .map((value: any) => {
          const header = this.headerArray?.find(
            (item: any) => item.enumValue === value
          );

          return header?.displayName;
        })
        .filter(Boolean);

      if (names.length <= 2) {
        return names.join(', ');
      }

      return `${names[0]}, ${names[1]} +${names.length - 2}`;
    }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
